import React from 'react';
import { QuickTipsInfoIcon } from '../icons/TourIcons';
import styles from '../stylesheets/tourOnboarding.module.scss';

interface QuickTipsStepProps {
  onContinue: () => void;
}

const QuickTipsStep = ({ onContinue }: QuickTipsStepProps) => {
  return (
    <div className={`${styles.stepContent} ${styles.quickTipsContent}`}>
      <div className={styles.sheetGrabber} aria-hidden="true" />
      <div className={styles.quickTipsHeader}>
        <div className={styles.quickTipsIcon}>
          <QuickTipsInfoIcon />
        </div>
        <h1 className={`${styles.title} ${styles.quickTipsTitle}`}>
          Quick Tips
        </h1>
        <p className={styles.quickTipsBody}>
          Follow the steps at the bottom.
          <br />
          Tap the highlighted area to continue.
          <br />
          Swipe this sheet up at any time.
        </p>
      </div>
      <button
        type="button"
        className={`${styles.primaryCta} ${styles.quickTipsCta}`}
        onClick={onContinue}
      >
        Let&apos;s go
      </button>
    </div>
  );
};

export default QuickTipsStep;
